// extracted by mini-css-extract-plugin
module.exports = {"container":"FeatureLink_container__3ooUr","icon":"FeatureLink_icon__11A_E"};